import React, { useContext, useState } from "react";
import Logo from '../../assets/Logo/123admissions white logo.svg'
import "./appAdminHeader.css";


const AppHeader = ({ setMenuToggle }) => {


  return (
    <div className="admin-app-header">

      <div>
        <div>
          <img src={Logo} style={{ width: "10%" }} ></img>
        </div>
      </div>
      <div>
        <div>
          <button className="btn btn-primary">admin</button>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
